import { AccountMovementsViewModel } from "../../../accounting/models/accounting-movement.model";

export class SocialCapitalModel {
    uid: number;
    amount: number;
    dateIncorporationOrExtension: Date;
    sharePremium: number;
    //Importación cuentas contables
    manualMovement: AccountMovementsViewModel;
    accountingModelsId: number;
    accountingModelsNumber: string;
}